<template>
  <div class="confirm-otp-container">
    <h1>
      Ellenőrizd az e-mailjeid!
    </h1>

    <v-alert v-model="alert" :type="alertType" close-text="Bezárás" dismissible @click="alert = false">
      {{ alertMessage }}
    </v-alert>

    <div class="separator"></div>

    <div class="confirm-otp-text">
      Biztonsági okokból küldtünk egy egyszer használatos kódot az e-mail címedre. Írd be a kapott kódot az alábbi
      mezőbe a folytatáshoz. Ha nem találod az e-mailt, ellenőrizd a Spam/Promóciók mappát is.
    </div>
    <div class="form-container">
      <div class="form-row">
        <label class="form-label">hitelesítő kód</label>
        <vpd-input v-model="otpCode" type="text" placeholder="123456" />
      </div>

      <div class="confirm-button-container">
        <div class="confirm-button" @click.prevent="confirm">
          <span v-if="!loading">folytatás</span>
          <img v-else :src="loaderIcon" class="spin" alt="Töltés" style="height:24px;" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./_vpd-confirm-otp-panel.scss";
import vpdInput from "../../vpd-input/vpd-input.vue";
import loaderIcon from "@/assets/loader.svg";

export default {
  name: "vpd-confirm-otp-panel",
  data() {
    return {
      loaderIcon,
      alert: false,
      alertType: "error",
      alertMessage: "",
      valid: false,
      otpCode: "",
      otpRules: [
        (v) => !!v || "A hitelesítő kód kötelező",
        (v) => /^\d{6}$/.test(v) || "A kód 6 számjegyből áll",
      ],
    };
  },
  components: { vpdInput },
  props: {
    loading: {
      type: Boolean,
    }
  },
  methods: {
    showAlert(text, type) {
      this.alert = true;
      this.alertType = type;
      this.alertMessage = text;
    },
    confirm() {
      // if (this.$refs.form.validate()) {
      //   this.$emit("submit", this.otpCode);
      // }
      this.$emit("submit", this.otpCode);
    },
  },
};
</script>
